"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import CommonInput from "@/components/utils/input/CommonInput";
import { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useMutation } from "@tanstack/react-query";
import { commonApiPut } from "@/services/api/common-api";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import { ApiUpdateProxyActionRequest } from "@/generated/models/ApiUpdateProxyActionRequest";
export default function ProfileProxyCreditEdit(t0) {
  const $ = _c(50);
  const {
    profileProxy,
    profileProxyAction,
    setViewMode
  } = t0;
  const {
    requestAuth,
    setToast
  } = useContext(AuthContext);
  const {
    onProfileProxyModify
  } = useContext(ReactQueryWrapperContext);
  const [creditAmount, setCreditAmount] = useState(profileProxyAction.credit_amount ?? 0);
  let t1;
  if ($[0] !== creditAmount || $[1] !== profileProxyAction.credit_amount) {
    t1 = () => {
      if (profileProxyAction.credit_amount === creditAmount) {
        return false;
      }
      if (creditAmount <= 0) {
        return false;
      }
      return true;
    };
    $[0] = creditAmount;
    $[1] = profileProxyAction.credit_amount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getIsChangedAndValid = t1;
  const [isChangedAndValid, setIsChangedAndValid] = useState(getIsChangedAndValid());
  let t2;
  if ($[3] !== getIsChangedAndValid) {
    t2 = () => setIsChangedAndValid(getIsChangedAndValid());
    $[3] = getIsChangedAndValid;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== creditAmount) {
    t3 = [creditAmount];
    $[5] = creditAmount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  const [submitting, setSubmitting] = useState(false);
  let t4;
  if ($[7] !== profileProxy || $[8] !== profileProxyAction.id) {
    t4 = async body => await commonApiPut({
      endpoint: `proxies/${profileProxy.id}/actions/${profileProxyAction.id}`,
      body
    });
    $[7] = profileProxy;
    $[8] = profileProxyAction.id;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onProfileProxyModify || $[11] !== profileProxy || $[12] !== setToast || $[13] !== setViewMode) {
    t5 = () => {
      if (!profileProxy.granted_to?.handle || !profileProxy.created_by?.handle) {
        return;
      }
      onProfileProxyModify({
        profileProxyId: profileProxy.id,
        grantedToHandle: profileProxy.granted_to.handle,
        createdByHandle: profileProxy.created_by.handle
      });
      setToast({
        message: "Action credit updated successfully!",
        type: "success"
      });
      setViewMode();
    };
    $[10] = onProfileProxyModify;
    $[11] = profileProxy;
    $[12] = setToast;
    $[13] = setViewMode;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== setToast) {
    t6 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[15] = setToast;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setSubmitting(false);
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t8 = {
      mutationFn: t4,
      onSuccess: t5,
      onError: t6,
      onSettled: t7
    };
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const profileProxyActionCreditMutation = useMutation(t8);
  let t9;
  if ($[22] !== creditAmount || $[23] !== profileProxyActionCreditMutation || $[24] !== requestAuth) {
    t9 = async () => {
      setSubmitting(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setSubmitting(false);
        return;
      }
      await profileProxyActionCreditMutation.mutateAsync({
        credit_amount: creditAmount
      });
    };
    $[22] = creditAmount;
    $[23] = profileProxyActionCreditMutation;
    $[24] = requestAuth;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const onSubmit = t9;
  let t10;
  if ($[26] !== creditAmount) {
    t10 = creditAmount.toString();
    $[26] = creditAmount;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = newV => setCreditAmount(parseInt(newV ?? "0"));
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10) {
    t12 = <div className="tw-w-full sm:tw-w-40"><CommonInput value={t10} inputType="number" onChange={t11} placeholder="Credit Amount" theme="light" size="sm" /></div>;
    $[29] = t10;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== setViewMode || $[32] !== submitting) {
    t13 = <button onClick={setViewMode} disabled={submitting} type="button" className="tw-w-full sm:tw-w-auto tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-800 hover:tw-bg-iron-700 tw-border tw-border-solid tw-border-iron-700 tw-text-iron-300 hover:tw-text-iron-50 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[31] = setViewMode;
    $[32] = submitting;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const t14 = `${!isChangedAndValid ? "tw-opacity-50" : "hover:tw-bg-primary-600 hover:tw-border-primary-600"} tw-w-full tw-flex tw-items-center tw-justify-center tw-relative tw-bg-primary-500 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-primary-500 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out`;
  let t15;
  if ($[34] !== submitting) {
    t15 = submitting && <CircleLoader size={CircleLoaderSize.SMALL} />;
    $[34] = submitting;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span>Update</span>;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t15) {
    t17 = <div className="tw-flex tw-items-center tw-space-x-2">{t15}{t16}</div>;
    $[37] = t15;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== onSubmit || $[40] !== submitting || $[41] !== t14 || $[42] !== t17) {
    t18 = <button onClick={onSubmit} disabled={submitting} type="button" className={t14}>{t17}</button>;
    $[39] = onSubmit;
    $[40] = submitting;
    $[41] = t14;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t13 || $[45] !== t18) {
    t19 = <div className="tw-mt-4 sm:tw-mt-0 tw-flex tw-items-center tw-justify-end sm:tw-justify-start tw-gap-x-3">{t13}{t18}</div>;
    $[44] = t13;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t12 || $[48] !== t19) {
    t20 = <div className="tw-h-full tw-py-3 xl:tw-h-14 tw-rounded-lg tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-iron-600"><div className="tw-h-full lg:tw-flex tw-items-center tw-px-3 tw-gap-x-3"><div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-justify-between tw-w-full tw-gap-x-3">{t12}{t19}</div></div></div>;
    $[47] = t12;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  return t20;
}